import { useState } from 'react'
import { doc, updateDoc } from 'firebase/firestore'
import { useToast } from '@chakra-ui/react'
import { DentalDetails } from '../../../../../types/FirestoreUser'
import { getEffectiveServices } from '../../../../../utils/firebaseServiceContext'

const useSubmitDentalDetails = (
  initialDentalDetails: Partial<DentalDetails>,
  uid: string
) => {
  const [loading, setLoading] = useState(false)
  const toast = useToast()

  const submit = async (detailsToSubmit?: Partial<DentalDetails>) => {
    if (!uid) {
      toast({
        status: 'error',
        title: 'Error',
        description: 'User not logged in',
        isClosable: true,
      })
      return
    }

    setLoading(true)

    try {
      // Use the provided details if available, otherwise use initialDentalDetails
      const dentalDetails = detailsToSubmit || initialDentalDetails

      // Filter out undefined values to prevent Firestore error
      const filteredDentalDetails: Record<string, any> = {}
      Object.entries(dentalDetails).forEach(([key, value]) => {
        if (value !== undefined) {
          filteredDentalDetails[key] = value
        }
      })

      // Use the provided UID if it exists, otherwise use the current user's UID
      const userRef = doc(getEffectiveServices().firestore, 'users', uid)
      await updateDoc(userRef, {
        dentalDetails: filteredDentalDetails,
      })

      toast({
        status: 'success',
        title: 'Saved',
        description: 'Dental details were successfully saved!',
        isClosable: true,
        duration: 5000,
      })
    } catch (e) {
      console.error(e)
      toast({
        status: 'error',
        title: 'Error',
        description: 'An error occurred while saving dental details.',
        isClosable: true,
        duration: null,
      })
    } finally {
      setLoading(false)
    }
  }

  return { submit, loading }
}

export default useSubmitDentalDetails
